<template>
  <div class="pinMsgV2">
    <el-dialog
      class="dialogLimitPinMsg"
      v-if="showDialog"
      width="348px"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      @close="closeDialog()"
      :destroy-on-close="true"
      :show-close="false">
      <div class="px-3 py-3">
        <div class="d-flex justify-content-center mb-2">
          <IconV2
            name="v2-info1"
            color="#FDAF36"
            size="24px" />
        </div>
        <div class="text-center text-normal text-break fw-400 px-2">Đã đạt giới hạn tin nhắn ghim. Vui lòng chọn ghim cần bỏ để cập nhật ghim mới:</div>
        <div class="mt-3">
          <div
            v-for="(item, index) in pinMessages"
            :key="index"
            class="rounded-2 mb-2"
            :class="checkSelected(item) ? 'pinMsg-active' : 'pinMsg'">
            <div
              @click.stop.prevent="selectItem(item)"
              class="d-flex pin py-1 pointer">
              <div class="mx-12 pointer align-self-center">
                <input
                  type="radio"
                  :checked="checkSelected(item)" />
              </div>
              <div
                class="d-flex flex-1 flex-column"
                style="width: 100%">
                <div class="font-13 text-grey600">
                  <span class="fw-500">{{ item.senderName }}</span>
                  • {{ formatDatetime(1714455406822) }}
                </div>
                <div v-if="![49, 32, 44, 38].includes(item.msg_type)">
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    :content="getContentPinMessage(item)"
                    placement="top-start">
                    <div
                      class="text-1-line-replied text-break"
                      style="display: inline-block; white-space: pre-line; color: #7589a3">
                      {{ getContentPinMessage(item) }}
                    </div>
                  </el-tooltip> -->
                  <div
                    class="text-1-line-replied text-break"
                    style="display: inline-block; white-space: pre-line; color: #7589a3">
                    {{ getContentPinMessage(item) }}
                  </div>
                </div>
                <div
                  v-else
                  class="d-flex my-1">
                  <el-image
                    class="rounded-2 me-2"
                    :src="getHref(item)"
                    style="object-fit: cover; height: 24px; width: 24px">
                    <IconV2
                      class="mt-1"
                      slot="error"
                      name="v2-image"
                      size="1.25rem" />
                  </el-image>
                  <a
                    :href="getHref(item)"
                    style="white-space: pre-line"
                    target="_blank"
                    class="flex-1 text-normal align-self-end text-break text-1-line white-sc">
                    {{ getThumb(item) }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3 fw-semibold">
          <span
            class="edit-button font-14 me-3 rounded-2 pointer px-3 d-flex align-items-center"
            style="height: 36px"
            @click="closeDialog()">
            Hủy
          </span>
          <span
            class="share-button font-14 rounded-2 pointer px-3 d-flex align-items-center"
            style="height: 36px"
            @click="actionUpdate()">
            Cập nhật
          </span>
        </div>
      </div>
    </el-dialog>
    <div v-if="pinMessages.length > 0">
      <div
        class="d-flex position-relative px-12"
        style="max-height: 54px; min-height: 54px; border-bottom: 1px solid #f4f5f9">
        <div
          v-if="!isShowAllPinMessages"
          class="d-flex text-normal w-100 pin-message">
          <div
            class="d-flex flex-1 justify-content-between py-2 flex-column pointer"
            @click="onClickPinMsg(pinMessages[0])">
            <div class="font-13 fw-500 text-grey600">{{ pinMessages[0].senderName }}</div>
            <div v-if="![49, 32, 44, 38].includes(pinMessages[0].msg_type)">
              <div
                class="text-1-line-replied text-break mb-1 font-13"
                style="white-space: pre-line; color: #202125">
                {{ getContentPinMessage(pinMessages[0]) }}
              </div>
            </div>

            <div
              v-else
              class="d-flex mb-1">
              <el-image
                class="rounded-2 me-2"
                :src="getHref(pinMessages[0])"
                style="object-fit: cover; height: 24px; width: 24px">
                <IconV2
                  class="mt-1"
                  slot="error"
                  name="v2-image"
                  size="1.25rem" />
              </el-image>
              <a
                :href="getHref(pinMessages[0])"
                style="white-space: pre-line"
                target="_blank"
                class="flex-1 text-normal align-self-end text-break text-1-line-replied">
                {{ getThumb(pinMessages[0]) }}
              </a>
            </div>
          </div>
          <div class="d-flex">
            <el-tooltip
              slot="reference"
              effect="dark"
              content="Bỏ ghim"
              placement="top">
              <div
                @click="unPin(pinMessages[0])"
                class="rounded-pill pin-v2 pointer align-self-center"
                style="padding: 7px">
                <IconV2 name="v2-mark-remove" />
              </div>
            </el-tooltip>

            <div
              v-if="pinMessages.length > 1"
              @click.stop="openPinMessageDropdown()"
              class="pin-v2 text-center align-self-center rounded-pill ms-2 pointer font-14 fw-400 px-3 py-1">
              Xem đầy đủ ({{ pinMessages.length }})
              <i class="el-icon-caret-bottom ms-1"></i>
            </div>
          </div>
        </div>
        <el-collapse-transition>
          <div
            v-show="isShowAllPinMessages"
            id="show-all-pinMessage"
            class="position-absolute w-100"
            v-click-outside="closePinMessage"
            style="z-index: 999; background-color: white; left: 0">
            <div class="">
              <div class="d-flex flex-1 px-12 py-2 border-bottom">
                <div
                  class="d-flex flex-grow-1 flex-column pointer"
                  @click="onClickPinMsg(pinMessages[0])">
                  <div class="text-grey600">
                    <span class="fw-semibold">{{ pinMessages[0].senderName }}</span>
                    • {{ formatDatetime(pinMessages[0].editTime) }}
                  </div>
                  <div v-if="![49, 32, 44, 38].includes(pinMessages[0].msg_type)">
                    {{ getContentPinMessage(pinMessages[0]) }}
                  </div>
                  <div
                    v-else
                    class="d-flex my-1">
                    <el-image
                      class="rounded-2 me-2"
                      :src="getHref(pinMessages[0])"
                      style="object-fit: cover; height: 24px; width: 24px">
                      <IconV2
                        class="mt-1"
                        slot="error"
                        name="v2-image"
                        size="1.25rem" />
                    </el-image>
                    <a
                      :href="getHref(pinMessages[0])"
                      style="white-space: pre-line"
                      target="_blank"
                      class="flex-1 text-normal align-self-end text-break text-1-line white-sc">
                      {{ getThumb(pinMessages[0]) }}
                    </a>
                  </div>
                </div>

                <div class="d-flex">
                  <el-tooltip
                    slot="reference"
                    effect="dark"
                    content="Bỏ ghim"
                    placement="top">
                    <div
                      @click="unPin(pinMessages[0])"
                      class="rounded-pill pin-v2 pointer align-self-center"
                      style="padding: 7px">
                      <IconV2 name="v2-mark-remove" />
                    </div>
                  </el-tooltip>

                  <div
                    v-if="pinMessages.length > 1"
                    @click.stop="closePinMessage()"
                    style="min-width: 110px"
                    class="pin-v2 text-center align-self-center rounded-pill ms-2 pointer font-14 fw-400 px-3 py-1">
                    Thu gọn
                    <i class="el-icon-caret-top ms-1"></i>
                  </div>
                </div>
              </div>

              <div
                class="d-flex flex-1 px-12 py-2 border-bottom"
                v-for="(item, index) in pinMessages.filter((p, i) => i)"
                :key="index">
                <div
                  class="d-flex flex-grow-1 flex-column pointer"
                  @click="onClickPinMsg(item)">
                  <div class="text-grey600">
                    <span class="fw-semibold">{{ item.senderName }}</span>
                    • {{ formatDatetime(item.editTime) }}
                  </div>
                  <div v-if="![49, 32, 44, 38].includes(item.msg_type)">
                    {{ getContentPinMessage(item) }}
                  </div>
                  <div
                    v-else
                    class="d-flex my-1">
                    <el-image
                      class="rounded-2 me-2"
                      :src="getHref(item)"
                      style="object-fit: cover; height: 24px; width: 24px">
                      <IconV2
                        class="mt-1"
                        slot="error"
                        name="v2-image"
                        size="1.25rem" />
                    </el-image>
                    <a
                      :href="getHref(item)"
                      style="white-space: pre-line"
                      target="_blank"
                      class="flex-1 text-normal align-self-end text-break text-1-line white-sc">
                      {{ getThumb(item) }}
                    </a>
                  </div>
                  <div></div>
                </div>

                <div class="d-flex">
                  <el-tooltip
                    slot="reference"
                    effect="dark"
                    content="Bỏ ghim"
                    placement="top">
                    <div
                      @click="unPin(item)"
                      class="rounded-pill pin-v2 pointer align-self-center"
                      style="padding: 7px">
                      <IconV2 name="v2-mark-remove" />
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMON } from "../../lib/Common";
import moment from "moment";

export default {
  name: "PinMessages",
  props: {
    pinMessages: {
      type: Array,
      default() {
        return [];
      },
    },
    conversation: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showAllInDialog: true,
      isShowAllPinMessages: false,
      isShowPopUpMore: false,
      visible: false,
      showDialog: false,
      selectedItems: [],
      selectedNeedPin: {},
    };
  },
  methods: {
    formatDatetime(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    closeDialog() {
      this.selectedItems = [];
      this.selectedNeedPin = {};
      this.showDialog = false;
      this.showAllInDialog = false;
    },
    selectItem(item) {
      const index = this.selectedItems.indexOf(item);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems = [item];
      }
    },
    checkSelected(item) {
      return this.selectedItems.some((s) => s.client_msg_id === item.client_msg_id);
    },
    async actionUpdate() {
      if (this.showAllInDialog) {
        if (this.selectedItems.length === 0) {
          return this.alert("error", "Vui lòng chọn ghim cần gỡ");
        } else {
          for (const s of this.selectedItems) {
            await this.unPin(s);
          }
          this.pinMessages
            .filter((x) => this.selectedItems.map((s) => s.client_msg_id).includes(x.client_msg_id))
            .forEach((x) => this.pinMessages.splice(this.pinMessages.indexOf(x), 1));
        }
      } else {
        await this.unPin(this.pinMessages[2]);
        const index = this.pinMessages.indexOf(this.pinMessages[2]);
        if (index > -1) {
          this.pinMessages.splice(index, 1);
        }
      }
      this.showAllInDialog = false;
      this.pinMessage(this.selectedNeedPin);
      this.showDialog = false;
    },
    pinMessage(message) {
      if (this.pinMessages.length > 2) {
        this.showDialog = true;
        this.selectedNeedPin = message;
        return;
      }
      let request = {
        group: this.conversation.group,
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        conversationId: this.conversation.toId,
        clientMsgId: message.cliMsgId,
        globalMsgId: message.id.msgId,
        senderId: message.id.uidFrom !== "0" ? message.id.uidFrom : this.conversation.accountId,
        senderName: this.getAccountName(this.app.accounts.find((s) => s.accountId === this.conversation.accountId)),
        msgType: this.getMsgType(message),
        message: this.getMessageToPin(message),
      };
      if (this.getMessageToPin(message) === 46) {
        request.extra = JSON.parse(message).params;
      }
      this.$http.post("/api/message/pin", request).then((resp) => {
        let data = resp.data;
        if (data.error_code === 0) return this.alert("success", "Ghim tin nhắn thành công");
        if (data.error_code === 315) return this.alert("error", "Yêu cầu thực hiện không thành công vì bạn hoặc người này đã chặn nhau");
        // if (data.error_code === 268) return this.alert("error", "dang full");
      });
      this.selectedItems = [];
      this.selectedNeedPin = {};
    },
    open() {
      this.isShowPopUpMore = true;
    },
    openPopup(item) {
      this.isShowPopUpMore = true;
      item.visible = !item.visible;
    },
    async unPin(message) {
      this.visible = false;
      let request = {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.toId,
        topicType: message.type,
        topicId: message.id,
        group: this.conversation.group,
      };
      await this.$http
        .post("/api/message/unpin", request)
        .then((resp) => {
          if (resp.data.error_code !== 0) {
            this.alert("error", "Không thể bỏ ghim tin nhắn này");
          }
        })
        .finally(() => (message.visible = false));
    },
    copy(message) {
      let code = message.content;
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      message.visiblePopup = false;
    },
    actionCopy(pinMessage) {
      if (pinMessage.msgType === COMMON.WEBCHAT) {
        this.copy(pinMessage);
        this.isShowPopUpMore = false;
      }
    },
    showCopy(pinMessage) {
      return [COMMON.WEBCHAT].includes(pinMessage.msgType);
    },
    openPinMessageDropdown() {
      this.isShowAllPinMessages = true;
      this.$emit("createOverScreen");
    },
    closePinMessage() {
      this.isShowAllPinMessages = false;
      this.pinMessages.forEach((s) => (s.visible = false));
      this.$emit("removeOverScreen");
    },
    getHref(item) {
      if (item.thumb !== undefined && item.thumb !== null && item.thumb !== "") {
        return item.thumb;
      } else {
        return item.title;
      }
    },
    getThumb(message) {
      if (message.msg_type === 38) {
        return "Danh thiếp:  " + message.title;
      } else {
        return message.thumb;
      }
    },

    getContentPinMessage(message) {
      switch (message.msg_type) {
        case 1: {
          return message.title;
        }
        case 46: {
          return message.title;
        }
        case 31: {
          return "[Ghi âm]";
        }
        case 43: {
          return message.title;
        }
        case 36: {
          return "Sticker";
        }
      }
    },
    onClickPinMsg(pinMsg) {
      this.$emit("onClickPinMsg", {
        cliMsgId: pinMsg.client_msg_id,
        ts: pinMsg.client_msg_id,
      });
    },
  },
};
</script>

<style lang="scss">
.pinMsgV2 {
  .share-button:hover {
    background-color: #0a58c0;
  }

  .share-button {
    color: #fff;
    background-color: #0068ff;
  }

  .edit-button:hover {
    background-color: #b6bec9;
  }

  .edit-button {
    background-color: #eaedf0;
    /*margin-left: auto;*/
  }
}

.dialogLimitPinMsg {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}

.pinMsg {
  border: 1px solid #eaecf2;
}
.pinMsg-active {
  border: 1px solid #73afff;
  background-color: rgba(225, 237, 253, 0.32);
}
</style>